import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CHECKOUT_FIELD_GAP } from '@client/components/checkout/checkoutLayout';
import { Box, Presence, Skeleton, Stack } from '@chakra-ui/react';
import { PaymentElement } from '@stripe/react-stripe-js';
import { useState } from 'react';
const FormSkeleton = () => (_jsxs(Stack, { gap: CHECKOUT_FIELD_GAP, height: "100%", children: [_jsx(Skeleton, { flex: 1 }), _jsx(Skeleton, { flex: 1 }), _jsx(Skeleton, { flex: 1 })] }));
export const CheckoutPaymentForm = ({ disabled }) => {
    const [ready, setReady] = useState(false);
    return (_jsxs(Box, { position: "relative", children: [_jsx(Presence, { present: !ready, position: "absolute", inset: 0, children: _jsx(FormSkeleton, {}) }), _jsxs(Box, { visibility: ready ? 'visible' : 'hidden', ...(!ready && { minHeight: 200 }), opacity: disabled ? 0.5 : 1, transition: "opacity 0.2s", children: [_jsx(PaymentElement, { options: {
                            layout: 'tabs',
                            readOnly: disabled,
                            wallets: {
                                applePay: 'never',
                                googlePay: 'never',
                            },
                        }, onReady: () => setReady(true) }), disabled && (_jsx(Box, { position: "absolute", inset: 0, cursor: "not-allowed" }))] })] }));
};
